<template>
    <section class="gmp-section gmp-mb-l">
        <div class="subpage-hero subpage-hero--no-padding">
            <div class="two-column-tout two-column-tout--fullbleed">
                <div class="two-column-tout__side">
                    <div class="two-column-tout__half-page two-column-tout__half-page--left">
                        <div class="two-column-tout__half-grid two-column-tout__half-grid--left">
                            <div class="two-column-tout__col">
                                <h1 class="h-c-headline h-c-headline--display-two">
                                    支持多渠道经营
                                </h1>
                                <h2 class="h-u-mb-std two-column-tout__description">
                                    线上线下一体化管理：小程序可以将线上订单与线下销售结合起来，售卖窗口可以轻松管理各个渠道的订单，优化整体运营。
                                    会员管理与促销：通过小程序，售卖窗口可以更好地管理会员，推出个性化的促销活动，吸引并留住更多客户。
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="two-column-tout__side">
                    <div class="two-column-tout__image two-column-tout__image--right">
                        <picture>
                            <img src="@/assets/img/ds_special.png" alt="The finer points." class="gmp-no-grab " >
                        </picture>
                    </div>
                </div>

            </div>

        </div>



    </section>

</template>

<script>
    export default {
        name: "WIN_two_column_fullbleed"
    }
</script>

<style lang="less">
h2{
    font-size: 18px;
    font-weight: 300;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}

</style>